import React from 'react';
import {Container,Grid} from '@material-ui/core';
import Youtube from './youtube';
import FBFeed from './facebookFeed';
import TwitterFeeds from './twitterFeeds.jsx';

const SocialFeeds:React.FC =  ()=>{
  return(
    <div className="section-break-2">
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12} lg={4} sm={6} xl={4}>
            <Youtube/>
          </Grid>
          <Grid item xs={12} lg={4} sm={6} xl={4}>
            <FBFeed/>
          </Grid>
          <Grid item xs={12} lg={4} sm={6} xl={4}>
            <TwitterFeeds/>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default SocialFeeds;